import {Selector} from '@ngxs/store';
import {MediaState} from '@store/media/media.state';
import {MediaStateModel} from '@store/media/media-state.model';
import {MediaTypeEnum} from '@shared/enums/media-type.enum';
import {IMediaItem} from '@interfaces/media';
import {ViewType} from '@shared/enums/view-type.enum';
import {IFolder, IFolderPath} from '@interfaces/folder';
import {MediaSortType} from '../../types/media.type';
import {OrderType} from '../../types/order.type';
import {UserSelectors} from '@store/user';

type CombinedItem =
    | { type: 'folder'; data: IFolder }
    | { type: 'media'; data: IMediaItem };
export class MediaSelectors {
    @Selector([MediaState])
    static getProofOnly(state: MediaStateModel): boolean {
        return state.proofOnly;
    }

    @Selector([MediaState, UserSelectors.getMediaHomeDirId])
    static isHomeDirectory(state: MediaStateModel, homeId: number | null): boolean {
        return homeId !== null && state.currentDirectory?.id === homeId;
    }

    @Selector([MediaState])
    static getAmountOfMedia(state: MediaStateModel): number {
        return state.contentItemAmount;
    }

    @Selector([MediaState])
    static getSelectedMediaType(state: MediaStateModel): MediaTypeEnum | '' {
        return state.selectedMediaType;
    }

    @Selector([MediaState])
    static getSortParams(state: MediaStateModel): { sort: MediaSortType, order: OrderType } {
        return {
            sort: state.sort,
            order: state.order
        };
    }

    @Selector([MediaState])
    static getMedia(state: MediaStateModel): IMediaItem[] {
        return state.medias;
    }

    @Selector([MediaState])
    static getMediaPerPage(state: MediaStateModel): number {
        return state.mediaPerPage;
    }

    @Selector([MediaState])
    static getMediaSearch(state: MediaStateModel): string {
        return state.searchParam;
    }

    @Selector([MediaState])
    static getViewType(state: MediaStateModel): ViewType | null {
        return state.viewType ?? ViewType.list;
    }

    @Selector([MediaState])
    static getCurrentPage(state: MediaStateModel): number {
        return state.currentPage;
    }

    @Selector([MediaState])
    static getLoaderStatus(state: MediaStateModel): boolean {
        return state.loader;
    }

    @Selector([MediaState])
    static getCurrentDirectory(state: MediaStateModel): IFolderPath | null {
        return state.currentDirectory;
    }

    @Selector([MediaState])
    static getFolders(state: MediaStateModel): IFolder[] {
        return state.folders;
    }

    @Selector([MediaState])
    static getCurrentFolder(state: MediaStateModel): IFolderPath | null {
        return state.currentDirectory;
    }

    @Selector([MediaState])
    static getItems(state: MediaStateModel): CombinedItem[] {
        const folders: CombinedItem[] = state.folders.map(folder => ({
            type: 'folder',
            data: folder
        }));

        const medias: CombinedItem[] = state.medias.map(media => ({
            type: 'media',
            data: media
        }));

        return [...folders, ...medias];
    }
}
